<template>
    <div class="transit-page-wrap">
      <div class="transit-page-logo-wrap" :style="{backgroundImage:'url('+orgInfo.logo+')'}"></div>
      <div class="transit-page-img"></div>
      <div class="transit-page-tips">
        您好，原地址已更新，请点击<a class="router-link" @click="toLink">{{orgInfo.adminUrl}}</a>新地址登录噢～
        <br>
        温馨提示：记得收藏保存最新的登录地址噢～
      </div>
    </div>
</template>

<script>
import {
  Button, Form, Input, FormItem, Checkbox, Dialog, Message, Tabs, TabPane, Loading,
} from 'element-ui';
import puzzle from '@/components/puzzle.vue';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import QRCode from 'qrcodejs2';
import api from '../api/index';

export default {
  name: 'home',
  components: {
    'el-button': Button,
    'el-form': Form,
    'el-input': Input,
    'el-form-item': FormItem,
    'el-checkbox': Checkbox,
    'el-dialog': Dialog,
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    swiper,
    swiperSlide,
    puzzle,
  },
  props:{
    orgInfo:{
      type:Object,
      default:{}
    }
  },
  data() {
    return {

    }
  },
  computed: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // 跳转
    toLink(){
      if(this.orgInfo.adminUrl){
        window.location.href = this.orgInfo.adminUrl
      }
    }
  },
};
</script>

<style lang="less" scoped>
  .transit-page-wrap{
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    background: #F8F8FA;
    padding: 24px 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .transit-page-logo-wrap{
      height: 38px;
      width: 100%;
      background-size:auto 100%!important;
      background-repeat:no-repeat;
    }
    .transit-page-img{
      width: 500px;
      height: 400px;
      margin-top: 148px;
      background: url('../assets/images/img_quesheng@2x.png') no-repeat;
      background-size: cover;
    }
    .transit-page-tips{
      color: #343537;
      font-size: 20px;
      line-height: 36px;
      .router-link{
        color: #4677F8;
        cursor: pointer;
      }
    }
  }
</style>
